import _extends from '@babel/runtime/helpers/esm/extends';
import _objectWithoutProperties from '@babel/runtime/helpers/esm/objectWithoutProperties';
import React, { useContext, useCallback } from 'react';
import ShuttleSource from './components/ShuttleSource.js';
import ShuttleTarget from './components/ShuttleTarget.js';
import { ShuttleContainer } from './classedComponents.js';
import AnimationContext from './AnimationState.js';
import '@babel/runtime/helpers/esm/defineProperty';
import 'prop-types';
import '@elliemae/ds-icons/ArrowShortRight';
import '@elliemae/ds-basic/Button';
import '@elliemae/ds-icons/Search';
import '@elliemae/ds-utilities/utils';
import './components/ShuttleSearchBox.js';
import '@babel/runtime/helpers/esm/classCallCheck';
import '@babel/runtime/helpers/esm/createClass';
import '@babel/runtime/helpers/esm/assertThisInitialized';
import '@babel/runtime/helpers/esm/inherits';
import '@babel/runtime/helpers/esm/possibleConstructorReturn';
import '@babel/runtime/helpers/esm/getPrototypeOf';
import '@elliemae/ds-classnames';
import '@elliemae/ds-basic/form/TextBox';
import './components/ShuttleInfiniteScrollIndicator.js';
import '@elliemae/ds-basic/IndeterminateProgressIndicator';
import './components/ShuttleListItem/ShuttleSourceListItem.js';
import '@babel/runtime/helpers/esm/slicedToArray';
import './helper.js';
import 'treetabular';
import './components/ShuttleListItem/ActionButtons.js';
import '@elliemae/ds-icons/CloseCircle';
import '@elliemae/ds-icons/ArrowShortReturn';
import './components/ShuttleListItem/ShuttleListItem.js';
import 'react-spring/web.cjs';
import '@elliemae/ds-basic/TruncatedTooltipText';
import 'react-sortable-hoc';
import '@elliemae/ds-icons/GripperVertical';
import './components/ShuttleListPanel.js';
import './components/VirtualizedList.js';
import 'react-window';
import 'react-window-infinite-loader';
import 'react-virtualized-auto-sizer';
import './animation/animationConfig.js';
import './components/VirtualizedItem.js';
import './SearchState.js';
import 'constate';
import './components/VirtualizedSortableList.js';
import './components/LoadingIndicator.js';
import '@elliemae/ds-basic/CircularProgressIndicator';
import 'styled-components';
import './components/ShuttleListItem/ShuttleTargetListItem.js';
import './components/ShuttleBreadcrumb.js';
import '@elliemae/ds-basic/Breadcrumb';
import './components/OverflowList.js';

var noop = function noop() {};

function ShuttleRenderer(_ref) {
  var containerProps = _ref.containerProps,
      _ref$onNavigateOnTarg = _ref.onNavigateOnTargetTo,
      onNavigateOnTargetTo = _ref$onNavigateOnTarg === void 0 ? noop : _ref$onNavigateOnTarg,
      _ref$onNavigateOnSour = _ref.onNavigateOnSourceTo,
      onNavigateOnSourceTo = _ref$onNavigateOnSour === void 0 ? noop : _ref$onNavigateOnSour,
      _ref$onMoveItemToSour = _ref.onMoveItemToSource,
      onMoveItemToSource = _ref$onMoveItemToSour === void 0 ? noop : _ref$onMoveItemToSour,
      _ref$onMoveItemToTarg = _ref.onMoveItemToTarget,
      onMoveItemToTarget = _ref$onMoveItemToTarg === void 0 ? noop : _ref$onMoveItemToTarg,
      _ref$onClearMovedItem = _ref.onClearMovedItems,
      _onClearMovedItems = _ref$onClearMovedItem === void 0 ? noop : _ref$onClearMovedItem,
      _ref$onMoveCheckedIte = _ref.onMoveCheckedItems,
      _onMoveCheckedItems = _ref$onMoveCheckedIte === void 0 ? noop : _ref$onMoveCheckedIte,
      _ref$onClearCheckedIt = _ref.onClearCheckedItems,
      onClearCheckedItems = _ref$onClearCheckedIt === void 0 ? noop : _ref$onClearCheckedIt,
      _ref$onToggleSearch = _ref.onToggleSearch,
      onToggleSearch = _ref$onToggleSearch === void 0 ? noop : _ref$onToggleSearch,
      _ref$onSearch = _ref.onSearch,
      onSearch = _ref$onSearch === void 0 ? noop : _ref$onSearch,
      _ref$onSearchClose = _ref.onSearchClose,
      onSearchClose = _ref$onSearchClose === void 0 ? noop : _ref$onSearchClose,
      _ref$onSearchOpen = _ref.onSearchOpen,
      onSearchOpen = _ref$onSearchOpen === void 0 ? noop : _ref$onSearchOpen,
      _ref$searching = _ref.searching,
      searching = _ref$searching === void 0 ? false : _ref$searching,
      _ref$onCheckItem = _ref.onCheckItem,
      onCheckItem = _ref$onCheckItem === void 0 ? noop : _ref$onCheckItem,
      _ref$hierarchy = _ref.hierarchy,
      hierarchy = _ref$hierarchy === void 0 ? [] : _ref$hierarchy,
      _ref$hierarchyDest = _ref.hierarchyDest,
      hierarchyDest = _ref$hierarchyDest === void 0 ? [] : _ref$hierarchyDest,
      _ref$checkedItems = _ref.checkedItems,
      checkedItems = _ref$checkedItems === void 0 ? [] : _ref$checkedItems,
      _ref$sourceItems = _ref.sourceItems,
      sourceItems = _ref$sourceItems === void 0 ? [] : _ref$sourceItems,
      _ref$targetItems = _ref.targetItems,
      targetItems = _ref$targetItems === void 0 ? [] : _ref$targetItems,
      sourceEmptyMessage = _ref.sourceEmptyMessage,
      targetEmptyMessage = _ref.targetEmptyMessage,
      composeTargetItemProps = _ref.composeTargetItemProps,
      composeSourceItemProps = _ref.composeSourceItemProps,
      targetSortable = _ref.targetSortable,
      sourceSortable = _ref.sourceSortable,
      onSourceSortEnd = _ref.onSourceSortEnd,
      onTargetSortEnd = _ref.onTargetSortEnd,
      _ref$loadingSource = _ref.loadingSource,
      loadingSource = _ref$loadingSource === void 0 ? false : _ref$loadingSource,
      _ref$loadingTarget = _ref.loadingTarget,
      loadingTarget = _ref$loadingTarget === void 0 ? false : _ref$loadingTarget,
      _ref$onGetMoreItems = _ref.onGetMoreItems,
      onGetMoreItems = _ref$onGetMoreItems === void 0 ? function () {} : _ref$onGetMoreItems,
      _ref$moreItemsLoading = _ref.moreItemsLoading,
      moreItemsLoading = _ref$moreItemsLoading === void 0 ? false : _ref$moreItemsLoading,
      _ref$hasNextPage = _ref.hasNextPage,
      hasNextPage = _ref$hasNextPage === void 0 ? false : _ref$hasNextPage,
      otherProps = _objectWithoutProperties(_ref, ["containerProps", "onNavigateOnTargetTo", "onNavigateOnSourceTo", "onMoveItemToSource", "onMoveItemToTarget", "onClearMovedItems", "onMoveCheckedItems", "onClearCheckedItems", "onToggleSearch", "onSearch", "onSearchClose", "onSearchOpen", "searching", "onCheckItem", "hierarchy", "hierarchyDest", "checkedItems", "sourceItems", "targetItems", "sourceEmptyMessage", "targetEmptyMessage", "composeTargetItemProps", "composeSourceItemProps", "targetSortable", "sourceSortable", "onSourceSortEnd", "onTargetSortEnd", "loadingSource", "loadingTarget", "onGetMoreItems", "moreItemsLoading", "hasNextPage"]);

  var _useContext = useContext(AnimationContext.Context),
      setIsMoving = _useContext.setIsMoving,
      setIsDrillingDown = _useContext.setIsDrillingDown,
      setIsMovingBack = _useContext.setIsMovingBack,
      reset = _useContext.reset;

  var removeAnimationState = useCallback(function () {
    return setTimeout(function () {
      return reset();
    }, 500);
  });
  return /*#__PURE__*/React.createElement(ShuttleContainer, _extends({
    "data-testid": "em-ds-shuttle"
  }, containerProps), /*#__PURE__*/React.createElement(ShuttleSource, _extends({}, otherProps, {
    checkedItems: checkedItems,
    composeSourceItemProps: composeSourceItemProps,
    emptyMessage: sourceEmptyMessage,
    hierarchy: hierarchy,
    items: sourceItems,
    onCheckItem: onCheckItem,
    onClearCheckedItems: onClearCheckedItems,
    onMoveCheckedItems: function onMoveCheckedItems(item) {
      setIsMoving(true);

      _onMoveCheckedItems(item);
    },
    onMoveItem: function onMoveItem(item) {
      setIsMoving(true);
      onMoveItemToTarget(item);
      removeAnimationState();
    },
    onNavigateTo: function onNavigateTo(item) {
      var direction = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'down';
      var indexInHierarchy = hierarchy.findIndex(function (hItem) {
        return hItem.id === item.id;
      });
      setIsDrillingDown(indexInHierarchy === -1);
      onNavigateOnSourceTo(item, direction);
    },
    onSearch: onSearch,
    onSearchClose: onSearchClose,
    onSearchOpen: onSearchOpen,
    onSortEnd: onSourceSortEnd,
    onToggleSearch: onToggleSearch,
    searching: searching,
    sourceSortable: sourceSortable,
    loading: loadingSource,
    onGetMoreItems: onGetMoreItems,
    moreItemsLoading: moreItemsLoading,
    hasNextPage: hasNextPage
  })), /*#__PURE__*/React.createElement(ShuttleTarget, _extends({}, otherProps, {
    composeTargetItemProps: composeTargetItemProps,
    emptyMessage: targetEmptyMessage,
    hierarchy: hierarchyDest,
    items: targetItems,
    onClearMovedItems: function onClearMovedItems() {
      setIsMovingBack(true);
      removeAnimationState();

      _onClearMovedItems();
    },
    onMoveItem: function onMoveItem(item) {
      setIsMovingBack(true);
      removeAnimationState();
      onMoveItemToSource(item);
    },
    onNavigateTo: function onNavigateTo(item) {
      var direction = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'down';
      var indexInHierarchy = hierarchyDest.findIndex(function (hItem) {
        return hItem.id === item.id;
      });
      setIsDrillingDown(indexInHierarchy === -1);
      onNavigateOnTargetTo(item, direction);
    },
    onSortEnd: onTargetSortEnd,
    targetSortable: targetSortable,
    loading: loadingTarget
  })));
}

export default ShuttleRenderer;
//# sourceMappingURL=ShuttleRenderer.js.map
